export const RECAPTCHA_BADGE_BODY_CLASS = "show-recaptcha-badge";
export const RECAPTCHA_BADGE_CLASS = ".grecaptcha-badge";
